<template>
	<div>
		<!-- 搜索条件区域 -->
		<div class="search-container">
			<div class="search-form">
				<div class="form-item">
					<span class="label">名称</span>
					<el-input v-model="queryParams.name" placeholder="请输入名称" clearable></el-input>
				</div>
				<div class="form-buttons">
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="handleResetSearch">重置</el-button>
					<el-button :disabled="multiple" type="primary" plain @click="handleRemoveAllCollect">
						批量取消收藏
					</el-button>
				</div>
			</div>
		</div>

		<!-- 列表区域 -->
		<data-table
			:table-data="useCollectPersonList"
			:column="columns"
			:page-options="pageOptions"
			:border="true"
			:loading="loading"
			:selection="true"
			:reserve-selection="true"
			:row-keys="handleRowKeys"
			@selectionChange="handleSelectDataChange"
			@page-change="handlePaginationChange"
		>
			<template slot="tools" slot-scope="data">
				<el-button @click="handleRemoveCollect(data.scope.row)">取消收藏</el-button>
				<el-button @click="handleLookDetail(data.scope.row)">查看详情</el-button>
			</template>
		</data-table>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { pageUserCollectPerson, removeUserCollect } from '@/api/userCenter/index'
	import { COLLECT_TYPE_STATE } from '@/enum'

	// 用户收藏的资质查-人员信息
	export default {
		name: 'CollectPerson',
		components: {
			DataTable
		},
		props: {},
		data() {
			return {
				queryParams: {
					name: ''
				},
				columns: [
					{ label: '名称', prop: 'name', align: 'center' },
					{ label: '收藏日期', prop: 'collectTime', width: '180', align: 'center' },
					{ label: '操作', prop: '', align: 'center', width: '280', slot: 'tools' }
				],
				// 用户收藏的资质查- 人员信息
				useCollectPersonList: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				// 非多个禁用
				multiple: true,
				// 选中的id集合
				selectIds: []
			}
		},
		computed: {},
		watch: {},
		created() {
			this.getUserCollectPersonList()
		},
		mounted() {},
		methods: {
			// 查询用户收藏的人员信息
			getUserCollectPersonList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				pageUserCollectPerson(params)
					.then(response => {
						const { data } = response
						if (data && data.records) {
							// 添加选择状态字段
							// this.useCollectPersonList = data.records.map(item => ({
							// 	...item,
							// 	selected: false
							// }))
							this.useCollectPersonList = data.records
							this.pageOptions.total = data.total || 0
						} else {
							this.useCollectPersonList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.useCollectPersonList = []
						this.pageOptions.total = 0
					})
			},

			handleRowKeys(row) {
				return row.id
			},

			// 选中回调
			handleSelectDataChange(selection) {
				this.selectIds = selection.map(item => item.id)
				this.multiple = !selection.length
			},

			// 分页变化
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.getUserCollectPersonList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 10
				this.getUserCollectPersonList()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					name: ''
				}
				this.getUserCollectPersonList()
			},

			// 用户取消收藏
			handleRemoveCollect(item) {
				const data = {
					collectType: COLLECT_TYPE_STATE.PERSON,
					collectIds: [item.id]
				}
				removeUserCollect(data).then(response => {
					this.getUserCollectPersonList()
				})
			},

			// 批量取消收藏
			handleRemoveAllCollect() {
				const selectedIds = this.selectIds

				const data = {
					collectType: COLLECT_TYPE_STATE.PERSON,
					collectIds: selectedIds
				}

				removeUserCollect(data).then(response => {
					this.getUserCollectPersonList()
				})
			},

			// 查看用户详情
			handleLookDetail(item) {
				this.$router.push({
					path: '/qualification-query/personDetail',
					query: {
						id: item.id // 传递详情ID参数
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	.table-list-container {
		.table-header {
			.header-item {
				&:last-of-type {
					flex: 0 0 226px;
				}
			}
		}
	}
</style>
